(function () {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('UserContacts', UserContacts);

    UserContacts.$inject = ['$resource'];

    function UserContacts ($resource) {
        var service = $resource('api/userContacts', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                	if(data!=null && data!="")
                		data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

